<template>
  <div>
    <a-modal :visible="hidden" title="覆盖配方" okText="确定" cancelText="取消" :maskClosable="false" @ok="handleOk"
      @cancel="handleCancel">
      <a-spin :spinning="loading">
        <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
          <a-form-model-item label="覆盖源配方：">
            <a-input v-model="sourceFormula.formulaName" disabled placeholder="覆盖源配方" />
          </a-form-model-item>
          <a-form-model-item label="覆盖源配方代码：">
            <a-input v-model="sourceFormula.formulaCode" disabled placeholder="覆盖源配方代码" />
          </a-form-model-item>
          <a-form-model-item label="工厂名称" prop="factoryId">
            <a-select v-model='form.factoryId' @change="handleFactoryChange">
              <a-select-option v-for="el in factoryArr" :key="el.factoryId" :value="el.factoryId">{{ el.name
                }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="配方：" prop="coverFormulaId" required >
            <a-select show-search v-model="form.coverFormulaId" placeholder="输入配方名称或代码"
              :default-active-first-option="false" :show-arrow="true" :filter-option="false" :not-found-content="null"
              @search="handleSearch" @change="handleFormulaChange($event)" @click="handleFocus" @dropdownVisibleChange="handleDropdownVisibleChange" style="width: 100%">
              <a-select-option v-for="item in formulaOptions" :key="item.id" :value="item.id">
                <span v-html="highlightKeyword(item.formulaName, searchKeyword)"></span>
                (<span v-html="highlightKeyword(item.formulaCode, searchKeyword)"></span>)
              </a-select-option>
            </a-select>
            <!-- <div v-if="form.coverFormulaId" class="selected-formula">
              已选择配方：<span class="selected-formula-name">{{ form.CopyformulaName }}</span> 
              <span class="selected-formula-code">({{ form.formulaCode }})</span>
            </div> -->
          </a-form-model-item>
        </a-form-model>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { nhfMixins } from "../../untils";

export default {
  mixins: [nhfMixins],
  props: {
    hidden: {
      type: Boolean,
      default: true,
    },
    formulaId: {
      type: [Number, String],
      default: null,
    },
    formulaName: {
      type: String,
      default: "",
    },
    formulaCode: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      form: {
        formulaName: "",
        formulaCode: "",
        factoryId: null,
        overwriteAll: true,
        CopyformulaName: "",
        coverFormulaId: undefined, // 使用undefined代替null以显示placeholder
      },
      rules: {
        formulaName: [
          { required: true, message: "请输入配方名称", trigger: "blur" },
        ],
        factoryId: [
          { required: true, message: "请选择工厂", trigger: "change" },
        ],
        coverFormulaId: [
          { required: true, message: "请选择配方", trigger: "change" },
        ],
      },
      loading: false,
      sourceFormula: {
        formulaName: "",
        formulaCode: "",
      },
      factoryArr: [],
      formulaOptions: [], // 存储搜索结果
      searchTimeout: null,
      searchKeyword: "", // 存储当前搜索关键词
    };
  },
  watch: {
    formulaId: {
      handler(val) {
        if (val) {
          // 切换配方时强制重置并加载新数据
          this.loading = true;
          // 先重置表单，避免数据混淆
          this.form = {
            formulaName: "",
            formulaCode: "",
            factoryId: null,
            overwriteAll: true,
            CopyformulaName: "",
            coverFormulaId: undefined,
          };
          this.sourceFormula = {
            formulaName: "",
            formulaCode: "",
          };

          // // 延迟执行确保DOM更新
          // this.$nextTick(async () => {
          //   await this.updateSourceFormula();
          //   // await this.getFormulaDetail();
          //   this.loading = false;
          // });
        }
      },
      immediate: true,
    },
    hidden(val) {
      if (val) {
        // 打开弹窗时，显示加载状态
        this.loading = true;
        
        // 先重置表单，确保placeholder可见
        this.resetForm();

        // 初始化数据
        Promise.all([
          this.getFactoryList(),
          this.updateSourceFormula(),

        ]).then(() => {
          if (this.formulaId) {
            return this.getFormulaDetail();
          }
        }).finally(() => {
          this.loading = false;
        });
      } else {
        // 关闭弹窗时重置表单
        this.resetForm();
      }
    },
    formulaName: {
      handler(val) {
        if (val) {
          this.updateSourceFormula();
        }
      },
      immediate: true
    },
    formulaCode: {
      handler(val) {
        if (val) {
          this.updateSourceFormula();
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.getFactoryList();
    this.updateSourceFormula();
  },
  methods: {
    // 高亮关键字
    highlightKeyword(text, keyword) {
      if (!keyword || !text) return text;

      try {
        // 创建正则表达式，i表示不区分大小写
        const regex = new RegExp(`(${keyword})`, 'gi');
        // 替换匹配的文本为带有红色样式的span
        return text.replace(regex, '<span style="color: red; font-weight: bold;">$1</span>');
      } catch (e) {
        // 如果正则表达式无效，直接返回原文本
        return text;
      }
    },

    // 处理配方搜索
    handleSearch(value) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      // 保存当前搜索关键词用于高亮显示
      this.searchKeyword = value;

      // 如果搜索关键字为空，清空选项并确保显示placeholder
      if (!value || value.trim() === '') {
        this.formulaOptions = [];
        // 确保清空值以显示placeholder
        this.form.coverFormulaId = undefined; // 使用undefined替代null
        return;
      }

      // 设置延迟，避免频繁请求
      this.searchTimeout = setTimeout(() => {
        this.searchFormulas(value);
      }, 300);
    },

    // 调用API搜索配方
    async searchFormulas(keyword) {
      try {
        // 使用不显示loading的API请求方式
        const res = await this.fetchGet({
          actions: this.myFormulaNhfPage,
          data: {
            formulaKeyword: keyword,
            current: 1,
            size: 10,
            status: 0,
            formulaType: 1,
            factoryId: this.form.factoryId
          },
          loading: false, // 明确指定不使用loading
          showMessage: false
        });

        if (res && res.success) {
          this.formulaOptions = res.data?.records || [];
        } else {
          this.$message.error(res.message || "搜索配方失败");
          this.formulaOptions = [];
        }
      } catch (error) {
        console.error("搜索配方出错:", error);
        this.$message.error("搜索配方出错");
        this.formulaOptions = [];
      }
    },

    // 处理工厂选择变化
    handleFactoryChange() {
      // 清空已选配方和配方列表
      this.form.coverFormulaId = undefined; // 使用undefined替代null
      this.form.CopyformulaName = "";
      this.formulaOptions = [];
    },

    // 处理下拉菜单可见性变化
    handleDropdownVisibleChange(visible) {
      if (visible) {
        // 下拉菜单显示时立即加载数据
        this.handleFocus();
      }
    },

    // 处理输入框获取焦点/点击时加载数据
    handleFocus() {
      // 如果已选择工厂，则加载该工厂的配方列表
      if (this.form.factoryId) {
        this.loadFactoryFormulas();
      } else {
        this.$message.info("请先选择工厂");
      }
    },

    // 加载工厂配方列表
    async loadFactoryFormulas() {
      // 不显示loading遮罩层
      try {
        const res = await this.fetchGet({
          actions: this.myFormulaNhfPage,
          data: {
            current: 1,
            size: 20,
            status: 0,
            formulaType: 1,
            factoryId: this.form.factoryId
          },
          loading: false, // 明确指定不使用loading
          showMessage: false
        });

        if (res && res.success) {
          this.formulaOptions = res.data?.records || [];
        } else {
          this.$message.error(res.message || "加载配方列表失败");
          this.formulaOptions = [];
        }
      } catch (error) {
        console.error("加载配方列表出错:", error);
        this.$message.error("加载配方列表出错");
        this.formulaOptions = [];
      }
    },

    // 处理配方选择变化
    handleFormulaChange(value) {
      // 根据选择的ID获取配方信息
      const selectedFormula = this.formulaOptions.find(item => item.id === value);


      if (selectedFormula) {
        // 设置表单中的配方名称和ID
        this.form.CopyformulaName = selectedFormula.formulaName; // 显示配方名称
        this.form.coverFormulaId = selectedFormula.id; // 使用formulaId而不是id
        this.form.formulaCode = selectedFormula.formulaCode; // 添加配方代码

        // console.log("Form data:", JSON.stringify(this.form));

        // 手动触发表单验证，清除错误提示
        this.$nextTick(() => {
          this.$refs.ruleForm && this.$refs.ruleForm.validateField('coverFormulaId');
        });
      }
    },

    async updateSourceFormula() {
      // Update the source formula with the provided name and code
      if (this.formulaName) {
        this.sourceFormula.formulaName = this.formulaName;
      }
      if (this.formulaCode) {
        this.sourceFormula.formulaCode = this.formulaCode;
      }

      if (this.factoryId) {
        this.form.factoryId = this.factoryId;
      }

      // 确保表单名称字段与源配方保持一致
      if (!this.form.formulaName && this.sourceFormula.formulaName) {
        this.form.formulaName = this.sourceFormula.formulaName;
      }
    },
    async getFactoryList() {
      try {
        const res = await this.fetchGet({
          actions: this.factoryList,
          data: { current: 1, size: 10000 }
        });
        if (res.data) this.factoryArr = res.data.records || [];
      } catch (error) {
        console.error(error);
        this.$message.error("获取工厂列表失败");
      }
    },

    // 获取配方详情
    async getFormulaDetail() {
      if (!this.formulaId) return;
      this.loading = true;
      try {
        const res = await this.fetchPost({
          actions: this.formulaRawNhfDetail,
          data: { formulaId: this.formulaId },
          showMessage: false
        });

        if (res && res.success) {
          const data = res.data || {};
          // 保留已设置的名称和代码，仅更新其他字段
          this.sourceFormula = {
            ...data,
            formulaName: this.formulaName || data.formulaName || "",
            formulaCode: this.formulaCode || data.formulaCode || ""
          };
          // 默认使用源配方的工厂
          this.form.factoryId = this.factoryId || data.formulaCode || ""
        }
      } catch (error) {
        console.error(error);
        this.$message.error("获取配方详情失败");
      } finally {
        this.loading = false;
      }
    },

    handleCancel() {
      this.$emit("cancel");
      // resetForm会在hidden watcher中处理
    },

    handleOk() {
      this.$refs.ruleForm.validate(valid => {
        if (!valid) return;
        this.doCover();
      });
    },

    async doCover() {
      this.loading = true;
      try {
        // 准备提交的数据
        const submitData = {
          id: this.formulaId,
          coverFormulaId: this.form.coverFormulaId,
        };

        this.$http.post('/nhf-app/formulaManage/coverFormula', submitData).then(res => {
          if (res && res.success) {
            // this.$message.success("配方覆盖成功");
            // 发送ok事件而非cancel，因为父组件的coverAction会调用toggleCoverVisible来关闭弹窗
            this.$emit('ok', true); 
          } else {
            this.$message.error("配方覆盖失败");
          }

        });

        
      } catch (error) {
        console.error(error);
        this.$message.error("配方覆盖失败");
      } finally {
        this.loading = false;
      }
    },

    resetForm() {
      this.form = {
        formulaName: "",
        formulaCode: "",
        factoryId: null,
        overwriteAll: true,
        CopyformulaName: "",
        coverFormulaId: undefined, // 使用undefined替代null
      };
      this.sourceFormula = {
        formulaName: "",
        formulaCode: "",
      };
      this.formulaOptions = [];
      this.searchKeyword = "";
      // 重置表单验证
      this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
.ant-form-item {
  margin-bottom: 15px;
}

.selected-formula {
  margin-top: 10px;
  padding: 5px;
  background-color: #f0f0f0;
  border-radius: 4px;
}

.selected-formula-name {
  font-weight: bold;
}

.selected-formula-code {
  margin-left: 10px;
}
</style>
